import angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { LiveMapAppUsageComponent } from './live-map-app-usage.component';

export default angular
    .module('control-room.experience-promoter.live-map.live-map-app-usage', [])
    .directive('crLiveMapAppUsage', downgradeComponent({ component: LiveMapAppUsageComponent }));
